import "antd/lib/form/style";
import _Form from "antd/lib/form";
import { connect } from 'dva';
import CI0304C from '../../components/CI/CI0304/Index';
function mapDispatchToProps(_ref) {
  var CI0304Info = _ref.CI0304Info;
  return {
    CI0304Info: CI0304Info
  };
}
var CI0304R = _Form.create()(CI0304C);
export default connect(mapDispatchToProps)(CI0304R);